import React, { useEffect, useState, useMemo } from 'react';
import { connect } from 'react-redux';
// import { Actions as LEAVEACTIONS } from '../../store/actions/leaveActions';
import { Actions as ASSETACTIONS } from '../../store/actions/assetActions';

import AuditLogs from '../auditLogs/AuditLogs';
import AuditLogModal from '../auditLogs/AuditLogModal';
import { format, addMonths } from 'date-fns'

const AssetAuditLogs = ({
    auditLogs,
    nextToken,
    getAssetAuditLogs,
    assetId
}) => {

    useEffect(() => {
        if (assetId) getAssetAuditLogs({ assetId })
    }, [assetId]);

    return (
        <>
            <AuditLogs auditLogs={auditLogs} nextToken={nextToken} getMoreLogs={getAssetAuditLogs} />
        </>
    );
};

const mapStateToProps = (state, ownProps) => {
    return {
        assetId: state.asset?.item?.id,
        auditLogs: state.asset?.auditLogs?.items || [],
        nextToken: state.asset?.auditLogs?.nextToken
    };
};

const mapDispatchToProps = (dispatch) => ({
    getAssetAuditLogs: ({ assetId, nextToken, from, to }) => dispatch(ASSETACTIONS.getAssetAuditLogs({ assetId, nextToken, from, to })),
});

export default connect(mapStateToProps, mapDispatchToProps)(AssetAuditLogs);